var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlertIc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-2, .cls-4 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-1, .cls-2 {\r\n        stroke: #5a5a5a;\r\n      }\r\n\r\n      .cls-1 {\r\n        opacity: 0;\r\n      }\r\n\r\n      .cls-2 {\r\n        stroke-linejoin: round;\r\n      }\r\n\r\n      .cls-3 {\r\n        stroke: none;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_13203",
    "data-name": "\\uADF8\\uB8F9 13203",
    transform: "translate(-427.242 -912.097)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uC0AC\\uAC01\\uD615_6419",
    "data-name": "\\uC0AC\\uAC01\\uD615 6419",
    className: "cls-1",
    transform: "translate(427.242 912.097)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 15
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_13703",
    "data-name": "\\uADF8\\uB8F9 13703",
    transform: "translate(429.978 913.155)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_18167",
    "data-name": "\\uD328\\uC2A4 18167",
    className: "cls-2",
    d: "M20.858,50.912a1.427,1.427,0,1,1-2.473,0",
    transform: "translate(-14.232 -39.418)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_31",
    "data-name": "\\uC120 31",
    className: "cls-2",
    y2: 1.555,
    transform: "translate(5.389)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_18166",
    "data-name": "\\uD328\\uC2A4 18166",
    className: "cls-2",
    d: "M12.277,16.831H1.5l.526-5.8a4.925,4.925,0,0,1,9.725,0Z",
    transform: "translate(-1.5 -5.335)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertIc);
export default __webpack_public_path__ + "static/media/alert_ic.e0bfe174d8a04bee6ffdba163331f9ad.svg";
export { ForwardRef as ReactComponent };